const MaritalStatusOptions = () => [
  { label: 'Lajang', value: 'Single' },
  { label: 'Menikah', value: 'Married' },
  { label: 'Cerai', value: 'Divorced' },
]

export default MaritalStatusOptions